<template>
    <div class="consultation-header1">
        <div>
            <img src="@/assets/image/rooms-banner.png" alt="" style="width:100%;margin-top: 80px;">
        </div>
        <div>
        <div class="header-first">
              <div style="display:flex;margin-top:30px">
                  <img src="@/assets/image/rooms11.png" alt="">
                  <div style="margin-left:45px;margin-top:120px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">高清音视频，一键入会</div>
                              <div style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">支持一键加入或发起视频会议</span></div>
                              <div style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">1080P高清视频，智能音频回声和降噪</span></div>
                          </div>
                      </div>
           
                  </div>
              </div>
          </div>
          <div class="header-first">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:140px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">屏幕共享，简单快捷</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">支持移动端/PC端，通过共享码一键投屏</span></p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/rooms21.png" alt="" style="margin-left:50px">
              </div>
          </div>
          <div class="header-first">
              <div style="display:flex;">
                  <img src="@/assets/image/rooms31.png" alt="">
                  <div style="margin-left:60px;margin-top:140px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">双屏显示，更加体验</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #656B90;line-height: 36px"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:15px"><span style="margin-left:8px">支持双屏显示，满足视频和共享数据分屏显示</span></p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="header-first">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:110px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">与会议室硬件配合实现更佳效果</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">可兼容主流的Windows/Android硬件</span></p>
                               <p style="width: 500px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">适配会议室平板一体机和硬件终端、及配套会议的音视频设备</span></p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/rooms2221.png" alt="" style="margin-left:50px">
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header1{
        width: 100%;
        .header-first{
            height: 420px;
            width:1200px;
            margin:0 auto
        }
    }
</style>